import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Divider,
  Typography,
} from "@suraasa/placebo-ui"
import { AssignmentFAQ } from "api/resources/assignments/types"

import AssignmentDetailSheet from "./AssignmentDetailSheet"

type Props = {
  faqs: AssignmentFAQ[]
  open: boolean
  onClose: () => void
}

const FAQsSheet = ({ faqs, open, onClose }: Props) => (
  <AssignmentDetailSheet
    title="Frequently Asked Questions (FAQs)"
    mobileTitle="FAQs"
    open={open}
    onClose={onClose}
  >
    <Accordion type="single" collapsible>
      {faqs.map((faq, index) => (
        <div key={index}>
          <AccordionItem value={`faq-${index}`}>
            <AccordionTrigger className="py-2">
              <Typography variant="strong">{faq.question}</Typography>
            </AccordionTrigger>
            <AccordionContent>
              <Typography className="pb-1 text-onSurface-500">
                {faq.answer}
              </Typography>
            </AccordionContent>
          </AccordionItem>
          {index !== faqs.length - 1 && <Divider weight="light" />}
        </div>
      ))}
    </Accordion>
  </AssignmentDetailSheet>
)

export default FAQsSheet
